import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api/axiosInstance";

export const getPaymentSettingsFunc = createAsyncThunk(
  "getAllPaymentSettings",
  async (query = "", thunkAPI) => {
    try {
      const res = await api.get(
        `dashboard/general-settings/payment-gateway-settings${query}`
      );

      return res.data.data.payments_gateway;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const getPaymentSettingsSlicer = createSlice({
  name: "getAllPaymentSettings",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducer: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentSettingsFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getPaymentSettingsFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(getPaymentSettingsFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getPaymentSettingsSlicer.reducer;
